import api from 'api'
import { PositionId, WorkerRequirementId } from './types'

/** @deprecated This endpoint will be deprecated in favor of unassignRequirementFromPosition */
export function removeRequirementFromPosition(
  positionId: PositionId,
  requirementId: WorkerRequirementId
) {
  return api
    .delete<void>('/admin/positions/requirements', {
      params: { position_id: positionId, requirement_id: requirementId },
    })
    .then((response) => {
      return response.data
    })
}
